import { saveAccessToken, saveRefreshToken } from "../../../api/apiClient";
import { ICreateLoginTicketRequest } from "../../../model/request/auth/ICreateLoginTicketRequest";
import { ILoginOIDCRequest } from "../../../model/request/auth/ILoginOIDCRequest";
import { ILoginRespone } from "../../../model/respone/auth/ILoginRespone";
import { IUserAuth } from "../../../model/respone/auth/IUserAuth";
import { IAccountLoginError, IAccountLoginStart, IAccountLoginSuccess, IAuthGetUserError, IAuthGetUserStart, IAuthGetUserSuccess, eAuthAcitonTypes } from "../../action-types/auth/IAuthActions";
import { baseAction } from "../IActionBase";

export const authActions = {
    getUserStart: (): IAuthGetUserStart => baseAction(eAuthAcitonTypes.GET_USER_START, undefined),
    getUserSuccss: (data: IUserAuth): IAuthGetUserSuccess => baseAction(eAuthAcitonTypes.GET_USER_SUCCESS, data),
    getUserError: (message?: string): IAuthGetUserError => baseAction(eAuthAcitonTypes.GET_USER_ERROR, message),

    loginStart: (request: ILoginOIDCRequest): IAccountLoginStart =>
        baseAction(eAuthAcitonTypes.LOGIN_START, request),
    loginSuccess: (response: ILoginRespone): IAccountLoginSuccess => {
        saveAccessToken(response.token_info.access_token)
        saveRefreshToken(response.token_info.refresh_token)
        return baseAction(eAuthAcitonTypes.LOGIN_SUCCESS, response);
    },
    loginError: (message: string): IAccountLoginError =>
        baseAction(eAuthAcitonTypes.LOGIN_ERROR, message),


    logOutStart: () => {
        localStorage.removeItem("access_token")
        localStorage.removeItem("refresh_token")
        return baseAction(eAuthAcitonTypes.LOGOUT_SUCCESS, undefined)
    }
}